import { Component, OnInit, Input, SimpleChange, Output, EventEmitter } from '@angular/core';
import { NormasService } from 'app/_services/normas.service';
import { SeguridadService } from 'app/_services/seguridad.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'historialnormasacciones',
  templateUrl: 'historialnormasacciones.component.html'
})
export class HistorialnormasaccionesComponent implements OnInit {

  @Input() idnorma: any;
  @Input() abr: any;

  @Output() onCloseHistorial = new EventEmitter<number>();

  id_norma: number;
  normaAbr: string;
  listaHistorial:  any = [];
  iconocerrar: string = 'fa fa-times';

  subscription: Subscription;

  constructor(private normasService:NormasService,
              private seguridad: SeguridadService,
              private router:Router) { }

  ngOnInit() {

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });
    
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['idnorma']){
      this.id_norma = changes['idnorma'].currentValue;
    }
    if (changes['abr']){
      this.normaAbr = changes['abr'].currentValue;
    }

    this.getNormaHistorial();

  }

  getNormaHistorial(){
    
    this.normasService.getNormaHistorial(this.id_norma).subscribe(
      data => {
        this.listaHistorial = data.json().historial;
      }
    )
  }

  cerrarHistorial(nivel:number){

    this.cerrarVentana(nivel);
  
  }

  cerrarVentana(destino:number){
    this.onCloseHistorial.emit(destino);
  }

}



// WEBPACK FOOTER //
// ./src/app/normas/historialnormasacciones.component.ts